import * as Yup from 'yup'

export const RegistrationSchema = Yup.object().shape({
  username: Yup.string().required('required'),
  password: Yup.string().min(8, 'minPassLength').required('required'),
  repeatPassword: Yup.string()
    .required('required')
    .oneOf([Yup.ref('password'), ''], 'passwordsDoNotMatch'),
  digitPhone: Yup.string().min(12, 'minPhoneLength').required('required'),
})
